import { Component, OnInit, OnDestroy, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from 'src/services/auth.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MiscService } from 'src/services/misc.service';
import { LocationService } from 'src/services/location.services';

@Component({
    selector: "rm-user",
    templateUrl: "./user.component.html",
    styleUrls: ["./user.component.css"]
  })
  export class UserComponent implements OnInit, OnDestroy {
    roles: any[] = [];
    participants: any[] = [];
    locations: any[] = [];

    mobileRegEx: string = "^[(]{0,1}[+0-9]{2,4}[)]{0,1}[0-9]{10}|[(]{0,1}[+][0-9]{1,2}-[0-9]{3,4}[)]{0,1}[0-9]{10}$";

    userFormGroup = new FormGroup({
        firstName: new FormControl(),
        lastName: new FormControl(),
        email: new FormControl(),
        dappUserId: new FormControl(),
        role: new FormControl(),
        isActive: new FormControl(true),
        password: new FormControl('', [Validators.minLength(8), Validators.maxLength(64)]),
        mobile: new FormControl('', Validators.maxLength(20)),
        // address: new FormControl(),
        nationalIDNumber: new FormControl(), // camtrade pass attribute
        gcp: new FormControl(),
        gln: new FormControl()
    });

    constructor(
        private dialogRef: MatDialogRef<UserComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private authService: AuthService,
        private miscService: MiscService,
        private locationService: LocationService
    ) {
    }

    ngOnInit() {

        this.authService.getRoles().subscribe(
            (result: any)=> {
                this.roles = result;
                var u = this.data.user;
                if (u) {
                    var o = {
                        firstName: u.firstName,
                        lastName: u.lastName,
                        dappUserId: u.dappUserId,
                        email: u.email,
                        role: u.role,
                        isActive: u.isActive,
                        password: 'thisisdummy',
                        mobile: u.mobile,
                        // address: u.address,
                        nationalIDNumber: u.nationalIDNumber ? u.nationalIDNumber : '', // camtrade pass attribute
                        gcp: u.gcp,
                        gln: u.gln
                    };
                    this.userFormGroup.setValue(o);
                    this.loadLocations(u.gcp);
                }
            }
        );

        this.miscService.getOrganisations().subscribe(
            (response: any)=> {
              this.participants = response['data'];
            }
        );
    }

    loadLocations(gcp) {
        this.locationService.get(gcp).subscribe(
            (response: any)=> {
              this.locations = response;
            }
        );
    }

    ngOnDestroy() {

    }

    onSubmit(values) {
        this.dialogRef.close(values);
    }

  }